import { ReactElement } from 'react'
/* eslint-disable @typescript-eslint/ban-ts-comment */
// Components
import { Mark } from '@mui/base'
import {
  ListItem,
  Stack,
  styled,
  ThemeProvider,
  Typography,
} from '@mui/material'
import { Slider } from './slider'
import { SettingsSection } from '$common/settings-section'
import { AvatarSize } from '$common/avatar/avatar-base/types'

const StyledListItem = styled(ListItem)`
  margin-top: 9px;
`

interface InviteLinkInputProps {
  marks: Mark[]
  value: number | number[]
  subheader: string
  description: string
  onChange: (value: number) => void
  inputComponent: ReactElement
}

export function CreateInviteLinkInput({
  onChange,
  value,
  marks,
  subheader,
  description,
  inputComponent,
}: InviteLinkInputProps) {
  return (
    <SettingsSection headerText={subheader} sx={{ paddingBottom: '7px' }}>
      <>
        <StyledListItem>
          <ThemeProvider
            theme={outerTheme => ({ ...outerTheme, direction: 'ltr' })}
          >
            <Slider
              size="small"
              marks={marks}
              color="secondary"
              value={value}
              onChange={onChange}
            />
          </ThemeProvider>
        </StyledListItem>
        <ListItem>
          {/* Don't Change Stack to Box or Fragment */}
          <Stack sx={{ width: '100%' }}>
            {inputComponent}
            <Typography color="gray" variant="caption1">
              {description}
            </Typography>
          </Stack>
        </ListItem>
      </>
    </SettingsSection>
  )
}
